import { useAxios } from '../../../../../../../../hooks/useAxios';
import { DocumentosAdapters } from '../adapters/documentos.adapter';

const DocumentosServices = {

    GET: function (idevento: string) {

        return useAxios({ method: 'get', url: `/slam/archivos/${idevento}`, type: 'json', adapters: DocumentosAdapters.GET })
    },

    POST: function () {

        return useAxios({ method: 'post', url: `/slam/archivo`, type: 'json', adapters: DocumentosAdapters.POST })
    },

    PATCH: function (idevento: string) {

        return useAxios({ method: 'patch', url: `/slam/archivo/${idevento}`, type: 'json', adapters: DocumentosAdapters.PATCH })
    },

    DELETE: function (id: any) {

        return useAxios({ method: 'delete', url: `/slam/archivo/${id}`, type: 'json', adapters: DocumentosAdapters.DELETE })
    }
}

export {
    DocumentosServices
}